/**
 * vuex state
 */
export default {
  test: [],
  times: 0,
  tabMenus: [], // 切换路由，同时保存成tab栏菜单
  subRouterInfo: null, // 当前子路由的信息
}
